



















































import {
  Component,
  Vue,
} from 'vue-property-decorator';
import {
  Action,
  namespace,
} from 'vuex-class';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons/faShoppingCart';

import { ProductVariant } from '@/models';
import { ADD_CART_ITEM_ACTION } from '@/store';

const AddToCartButtonProps = Vue.extend({
  props: {
    variant: {
      type: ProductVariant,
      default: null,
    },
    quantity: {
      type: Number,
      default: 1,
    },
  },
});

const cartStore = namespace('cart');

@Component({
  components: {
    FontAwesomeIcon,
  },
})
export default class AddToCartButton extends AddToCartButtonProps {
  public readonly faShoppingCart = faShoppingCart;

  @cartStore.Action(ADD_CART_ITEM_ACTION) public addCartItem: any;

  public onClick() {
    if (this.variant) {
      this.addCartItem({
        variant: this.variant,
        quantity: this.quantity,
      });
    }
  }
}

